import { render, staticRenderFns } from "./AppointmentNotes.vue?vue&type=template&id=6e015c68&"
import script from "./AppointmentNotes.vue?vue&type=script&lang=js&"
export * from "./AppointmentNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports